import React, { useEffect, useState } from "react";
import CloseForm from "../Master/CloseForm";
import "../../css_files/Technician/ViewEditVoucher.css";
import axiosInstance from "../../api";
import Select from "react-select";

export default function ViewEditSiteContact({
  isEdit,
  setShowSiteContact,
  siteContactId,
  refresh,
  setrefresh,
}) {
  const [siteContactData, setSiteContactData] = useState(null);
  const [files, setfiles] = useState([]);
  const [fileNames, setfileNames] = useState("");
  const [loading, setloading] = useState(false);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/SiteContact/GetSiteContactDetail/${siteContactId}`
      )
      .then((res) => {
        setSiteContactData(res.data);
      })
      .catch(console.log);
  }, [siteContactId]);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    const formdata = new FormData();
    formdata.append("Name", siteContactData?.name);
    formdata.append("Designation", siteContactData?.designation);
    formdata.append("Phone", siteContactData?.phone);
    formdata.append("Email", siteContactData?.email);
    formdata.append("BoilerDetails", siteContactData?.boilerDetails);
    formdata.append("Notes", siteContactData?.notes);

    for (const file of files) {
      formdata.append("Files", file);
    }
    formdata.append("Id", siteContactId);
    formdata.append("FileNames", fileNames);

    const apiCall = axiosInstance.put(
      `${process.env.REACT_APP_API_URL}/api/SiteContact/UpdateSiteContactDetails`,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    apiCall
      .then(() => {
        setrefresh(!refresh);
        setShowSiteContact(false);
      })
      .catch(console.log)
      .finally(() => setloading(false));
  }

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/User/GetAllRoles`)
      .then((res) => {
        setRoles(res?.data);
      })
      .catch(console.log);
  }, []);

  return (
    <div className="view-edit-voucher-technician">
      <form onSubmit={handleSubmit}>
        <center>
          <h2>{`${isEdit ? "Edit" : "View"} Site Contact`}</h2>
        </center>
        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: isEdit === false && 600 }}>
            Company Name:
          </label>

          <p>{siteContactData?.companyName || "N/A"}</p>
        </blockquote>
        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: isEdit === false && 600 }}>Name:</label>
          {isEdit ? (
            <input
              type="text"
              placeholder="Enter Site Contact Name"
              required
              value={siteContactData?.name}
              onChange={(e) => {
                setSiteContactData({
                  ...siteContactData,
                  name: e.target.value,
                });
              }}
            />
          ) : (
            <p>{siteContactData?.name}</p>
          )}
        </blockquote>
        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: isEdit === false && 600 }}>
            Designation:
          </label>
          {isEdit ? (
            <select
              required
              onChange={(e) => {
                setSiteContactData({
                  ...siteContactData,
                  designation: e.target.value,
                });
              }}
            >
              <option>Select Role</option>
              {roles.map((x) => (
                <option
                  value={x.roleName}
                  selected={siteContactData?.designation === x.roleName}
                >
                  {x.roleName}
                </option>
              ))}
            </select>
          ) : (
            <p>{siteContactData?.designation}</p>
          )}
        </blockquote>
        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: isEdit === false && 600 }}>
            Phone Number:
          </label>
          {isEdit ? (
            <input
              type="number"
              placeholder="Enter Phone Number"
              required
              value={siteContactData?.phone}
              onChange={(e) => {
                setSiteContactData({
                  ...siteContactData,
                  phone: e.target.value,
                });
              }}
              inputMode="numeric"
              min={1000000000}
              max={9999999999}
            />
          ) : (
            <p>{siteContactData?.phone}</p>
          )}
        </blockquote>
        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: isEdit === false && 600 }}>Email:</label>
          {isEdit ? (
            <input
              type="email"
              placeholder="Enter Email"
              required
              value={siteContactData?.email}
              onChange={(e) => {
                setSiteContactData({
                  ...siteContactData,
                  email: e.target.value,
                });
              }}
            />
          ) : (
            <p>{siteContactData?.email}</p>
          )}
        </blockquote>
        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: isEdit === false && 600 }}>
            Boiler Details:
          </label>
          {isEdit ? (
            <textarea
              value={siteContactData?.boilerDetails}
              placeholder="Enter Description"
              rows={4}
              onChange={(e) => {
                setSiteContactData({
                  ...siteContactData,
                  boilerDetails: e.target.value,
                });
              }}
              maxLength="500"
            ></textarea>
          ) : (
            <p>{siteContactData?.boilerDetails}</p>
          )}
        </blockquote>
        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: isEdit === false && 600 }}>Notes:</label>
          {isEdit ? (
            <textarea
              value={siteContactData?.notes}
              placeholder="Enter Notes"
              rows={4}
              onChange={(e) => {
                setSiteContactData({
                  ...siteContactData,
                  notes: e.target.value,
                });
              }}
            ></textarea>
          ) : (
            <p>{siteContactData?.notes}</p>
          )}
        </blockquote>
        {(isEdit ||
          siteContactData?.fileNames?.split(",")?.filter((x) => x != "")
            ?.length > 0) && (
          <>
            <blockquote>
              <label style={{ fontWeight: isEdit === false && 600 }}>
                Files
              </label>
              {isEdit && (
                <input
                  type="file"
                  multiple
                  onChange={(e) => {
                    setfiles(e.target.files);
                  }}
                />
              )}
            </blockquote>
            {siteContactData?.fileNames && (
              <ul>
                {siteContactData?.fileNames
                  ?.split(",")
                  ?.filter((x) => x != "")
                  ?.map((x) => (
                    <li>
                      <a
                        href={`${process.env.REACT_APP_API_URL}/siteFiles/${x}`}
                        target="_blank"
                      >
                        {x}
                      </a>
                      {isEdit && (
                        <i
                          className="fa-solid fa-xmark"
                          onClick={() => {
                            setfileNames((prev) => {
                              const arr = prev ? prev?.split(",") : [];
                              if (Array.isArray(arr)) {
                                arr.push(x);
                                return arr.join(",");
                              }
                              return "";
                            });
                            setSiteContactData((prev) => {
                              const arr = prev?.fileNames?.split(",") || [];
                              return {
                                ...prev,
                                fileNames: arr.filter((y) => y !== x).join(","),
                              };
                            });
                          }}
                        ></i>
                      )}
                    </li>
                  ))}
              </ul>
            )}
          </>
        )}
        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: isEdit === false && 600 }}>
            Address:
          </label>
          <p>{siteContactData?.address}</p>
        </blockquote>
        {isEdit && (
          <button type={loading ? "button" : "submit"}>
            {loading ? "Please Wait..." : "Submit"}
          </button>
        )}
        <CloseForm close={setShowSiteContact} />
      </form>
    </div>
  );
}
